import roleEnum from '@/common/role.enum'

export function canEditTicket (user, ticket) {
  const ownerId = ticket?.progressBy?.id
  if (!user || !ticket || !ownerId) return false

  // Owner can edit
  if (user?.id === ownerId) return true

  // AGENT: view team tickets, but edit only own
  if (user?.role === roleEnum.AGENT) return false

  // SUPERVISOR: can edit tickets in same team
  if (user?.role === roleEnum.SUPERVISOR) {
    return Boolean(user?.userTeamId && user?.userTeamId === ticket?.progressBy?.userTeamId)
  }

  // Higher roles: team or group access
  if ([roleEnum.SUPER_ADMIN, roleEnum.MANAGEMENT, roleEnum.MANAGER].includes(user?.role)) {
    return Boolean(
      (user?.userTeamId && user?.userTeamId === ticket?.progressBy?.userTeamId) ||
      (user?.userGroupId && user?.userGroupId === ticket?.progressBy?.userGroupId)
    )
  }

  return false
}

export function isTicketEditDisabled (user, ticket) {
  return !canEditTicket(user, ticket)
}

